// extracted by mini-css-extract-plugin
module.exports = {"email-preferences":"src-components-page-settings-tab-account-AccountTab-module__email-preferences--1GnYI"};